import { cdnTemplate } from 'cdnPreprocessor';

export default [
  '$location', '$window',
  function TwitterShare ($location, $window) {
    return {
      restrict: 'C',
      replace: true,
      templateUrl: cdnTemplate('/social-share-button.html'),
      scope: true,
      link: (scope) => {
        scope.share = function TwitterShareCall () {
          $window.open(`http://twitter.com/home?status=Check out this shirt on Viralstyle.com - ${encodeURIComponent($location.absUrl())}`, 'twitter', 'width=600,height=530');
        };
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/social-share/twitter.dir.js